import EmployeeData from './pages/EmployeeData';
import NotFound from './pages/NotFound';
import SiteLanding from './pages/SiteLanding';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ConsoleProviders } from './editor/ConsoleProviders';
import { ResetPasswordPage } from './editor/pages/ResetPasswordPage';
import { AdminRoutes } from './editor/routes/AdminRoutes';
import { EditorRoutes } from './editor/routes/EditorRoutes';

function App()
{
    return (
        <Routes>
            {/* Öffentlicher Bereich (außerhalb des Console-Provider-Stacks). */}
            <Route index element = {<SiteLanding/>}/>
            <Route path = 'error' element = {<NotFound/>}/>

            {/* Konsole: ein gemeinsamer Provider-Stack (Theme/Auth/Brand) über
                /admin/* + /editor/* (TP2 §D2). Statische Segmente schlagen die
                dynamische :urlKey-Viewer-Route (Ranking). Getrennte Logins pro
                Bereich (F2-Split): /admin/login (Passwort+OTP), /editor/login
                (OTP). Der alte zentrale /login bleibt als Bookmark-Redirect
                auf den Admin-Login bestehen. */}
            <Route element = {<ConsoleProviders/>}>
                <Route path = 'login' element = {<Navigate to = '/admin/login' replace/>}/>
                <Route path = 'reset-password' element = {<ResetPasswordPage/>}/>
                <Route path = 'admin/*' element = {<AdminRoutes/>}/>
                <Route path = 'editor/*' element = {<EditorRoutes/>}/>
            </Route>

            {/* Öffentlicher Viewer (dynamisch, zuletzt im Ranking). */}
            <Route path = ':urlKey' element = {<EmployeeData/>}/>
        </Routes>
    )
}

export default App;
